export default __webpack_public_path__ + "img/map-mobile.24893df0.jpg";